import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";

import image from "../logos/nodata.png";
import "./CommonDashboard.css";
import { useState } from "react";

import {
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import { Button } from "@mui/material";

import { useSelector, useDispatch } from "react-redux";

import { CssBaseline } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import { setStagedDevice } from "../redux/slices/stagedDeviceSlice";
import RejectedDeviceDialog from "./RejectedDeviceDialog";
import AcceptedDeviceDialog from "./AcceptedDeviceDialog";

import MyStagedDeviceForm from "./MyStagedDeviceForm";
import BulkAcceptandLinkModal from "./BulkAcceptandLink";
import { toast } from "react-toastify";

const api = localStorage.getItem("api");
const theme = createMuiTheme({
  spacing: 2,
  typography: {
    fontSize: 12,
  },
});

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiDataGrid-row.Mui-selected": {
      backgroundColor: "#e0e0e0",
    },
    "& .MuiDataGrid-columnHeader": {
      backgroundColor: "#fafafa",
    },
    "& .MuiDataGrid-cell": {
      fontWeight: "normal",
      fontSize: "0.75rem",
      color: "rgba(0, 0, 0, 0.87)",
      letterSpacing: "0.01071em",
    },
    "& .MuiDataGrid-cell--textLeft": {
      textAlign: "left",
    },
    "& .MuiDataGrid-cell--textCenter": {
      textAlign: "center",
    },
    "& .MuiDataGrid-cell--textRight": {
      textAlign: "right",
    },
    "& .MuiDataGrid-columnsContainer": {
      backgroundColor: "#fafafa",
    },
    "& .MuiDataGrid-iconSeparator": {
      display: "none",
    },
  },
  table: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: `calc(100% - ${theme.spacing(3)}px)`,
    overFlow: "hidden",
  },
  buttonDiv: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    padding: "0 10%",
  },
  bulkButtons: {
    display: "flex",
    gap: "1rem",
  },
}));

const StagedDeviceTable = ({ fetchData }) => {
  const [rows, setRows] = React.useState([]);

  const headers = useSelector((state) => state.header);
  const classes = useStyles();
  const dispatch = useDispatch();
  const stageddevicedata = useSelector((state) => state.stagedDevice);
  const [selectedIds, setSelectedIds] = useState([]);

  const [showAcceptedDialog, setShowAcceptedDialog] = useState(false);
  const [showRejectedDialog, setShowRejectedDialog] = useState(false);

  const columns = [
    { field: "id", headerName: "ID", flex: 1 },
    { field: "serial", headerName: "Serial", flex: 1 },

    { field: "ipAddress", headerName: "IP address", flex: 2 },
    {
      field: "portNumber",
      headerName: "Port Number",

      flex: 1,
    },
    { field: "model", headerName: "Model", flex: 1 },
    {
      field: "type",
      headerName: "Type",
      flex: 1,
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
    },
  ];

  const openAcceptedDialog = () => {
    setShowAcceptedDialog(true);
  };

  const closeAcceptedDialog = () => {
    setShowAcceptedDialog(false);
  };

  const openRejectedDialog = () => {
    setShowRejectedDialog(true);
  };

  const closeRejectedDialog = () => {
    setShowRejectedDialog(false);
  };

  const handleBulkAcceptConfirmed = () => {
    closeAcceptedDialog();
    handleBulkOperation();
  };

  const handleBulkDeleteConfirmed = () => {
    closeRejectedDialog();
    handleBulkDelete();
  };

  const handleRefresh = () => {
    fetchData();
  };

  const handleBulkOperation = () => {
    if (selectedIds?.length === 0) {
    } else {
      const requestBody = selectedIds?.map((id) => ({ id, meetinglinkid: "" }));

      axios
        .post(api + "/device/stage/accept", requestBody, headers)
        .then((response) => {
          const currentStagedDevice = stageddevicedata.stagedDevice;

          const updatedStagedDevice = [...currentStagedDevice];

          response.data.forEach((newRecord) => {
            const existingRecordIndex = updatedStagedDevice.findIndex(
              (record) => record.id === newRecord.id
            );

            if (existingRecordIndex !== -1) {
              updatedStagedDevice[existingRecordIndex] = newRecord;
            } else {
              updatedStagedDevice.push(newRecord);
            }
          });

          dispatch(setStagedDevice(updatedStagedDevice));
          toast.success("Accepted successfully", {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
          setSelectedIds(null);
        })
        .catch((error) => {
          console.error(error);
          toast.error("Couldn't be accepted", {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
          setSelectedIds(null);
        });
    }
  };

  const handleBulkDelete = () => {
    if (selectedIds?.length === 0) {
    } else {
      const requestBody = selectedIds?.map((id) => ({ id }));

      axios
        .post(api + "/device/stage/reject", requestBody, headers)
        .then((response) => {
          const currentStagedDevice = stageddevicedata.stagedDevice;

          const updatedStagedDevice = [...currentStagedDevice];

          response?.data?.forEach((newRecord) => {
            const existingRecordIndex = updatedStagedDevice.findIndex(
              (record) => record.id === newRecord.id
            );

            if (existingRecordIndex !== -1) {
              updatedStagedDevice[existingRecordIndex] = newRecord;
            } else {
              updatedStagedDevice.push(newRecord);
            }
          });

          dispatch(setStagedDevice(updatedStagedDevice));
          toast.success("Rejected successfully", {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
          setSelectedIds(null);
        })
        .catch((error) => {
          console.error(error);
          toast.error("Couldn't be rejected", {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
          setSelectedIds(null);
        });
    }
  };

  React.useEffect(() => {
    if (stageddevicedata.stagedDevice) {
      const filteredRows = stageddevicedata.stagedDevice.filter(
        (record) => record.status !== "moving" && record.status !== "moved"
      );
      setRows(filteredRows);
    }
  }, [stageddevicedata.stagedDevice, selectedIds]);

  return (
    <>
      <div className={classes.buttonDiv}>
        <div className={classes.bulkButtons}>
          <Button
            style={{ textTransform: "none" }}
            variant="outlined"
            onClick={openAcceptedDialog}
            disabled={selectedIds === null || selectedIds?.length === 0}
          >
            Accept Selected
          </Button>
          <BulkAcceptandLinkModal
            open={true}
            selectedIds={selectedIds}
            setSelectedIds={setSelectedIds}
            onClose={() => setSelectedIds(null)}
          />
          <Button
            style={{ textTransform: "none" }}
            color="error"
            variant="outlined"
            onClick={openRejectedDialog}
            disabled={selectedIds === null || selectedIds?.length === 0}
          >
            Reject Selected
          </Button>
          <Button
            style={{ textTransform: "none" }}
            variant="outlined"
            onClick={handleRefresh}
          >
            Refresh
          </Button>
        </div>
        <MyStagedDeviceForm />

        {selectedIds?.length > 0 ? (
          <>
            <AcceptedDeviceDialog
              open={showAcceptedDialog}
              onClose={closeAcceptedDialog}
              onConfirm={handleBulkAcceptConfirmed}
            />
            <RejectedDeviceDialog
              open={showRejectedDialog}
              onClose={closeRejectedDialog}
              onConfirm={handleBulkDeleteConfirmed}
            />
          </>
        ) : null}
      </div>

      {rows?.length > 0 ? (
        <CssBaseline>
          <ThemeProvider theme={theme}>
            <Table classes={classes.table}>
              <div style={{ padding: "2.5% 10%" }}>
                <DataGrid
                  rows={rows}
                  columns={columns}
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 5,
                      },
                    },
                  }}
                  pageSizeOptions={[5]}
                  checkboxSelection
                  selectionModel={selectedIds}
                  disableRowSelectionOnClick
                  onRowSelectionModelChange={(ids) => {
                    setSelectedIds(ids);
                  }}
                />
              </div>
            </Table>
          </ThemeProvider>
        </CssBaseline>
      ) : (
        <div className="error-container">
          <div className="error">
            <img className="img1" src={image} alt="" />
          </div>
        </div>
      )}
    </>
  );
};

export default StagedDeviceTable;
